import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { EducationType } from "../school/constants/types";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import LanguageCoursesPage from "./pages/LanguageCoursesPage";
import { useSchoolType } from "../school/hooks/useSchoolType";
import { LanguageCourseViewMorePage } from "./pages/LanguageCourseViewMorePage";

export function LanguageCoursesRoutes({ path }: { path: string }) {
  const schoolType = useSchoolType();

  const getCoursesPage = (type) => {
    switch (type) {
      case EducationType.Language:
        return LanguageCoursesPage;
      default:
        return NotFound;
    }
  };

  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.School]}
          component={getCoursesPage(schoolType)}
        />
        <AuthRoute
          exact
          path={`${path}/:id`}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
          ]}
          component={LanguageCourseViewMorePage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
